import { useState, useEffect } from 'react';
import { TrainingApi } from '@/features/agents';

export const useTrainingAccess = (moduleType: string) => {
  const [hasAccess, setHasAccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const checkAccess = async () => {
    try {
      setLoading(true);
      const response = await TrainingApi.checkUserAccess(moduleType);
      setHasAccess(response.hasAccess);
    } catch (error) {
      console.error('Error checking training access:', error);
      setHasAccess(false);
    } finally {
      setLoading(false);
    }
  };

  const refreshAccess = () => {
    checkAccess();
  };

  useEffect(() => {
    checkAccess();
  }, [moduleType]);

  return { hasAccess, loading, refreshAccess };
};
